export class Config {
  public static config = {
    theme: 'horizontal', // vertical, collapsed, horizontal
    themeType: 'default' // default, dark, light
  };
}
